import CaseStudy from "@/types/CaseStudy";

const WORDS_PER_MINUTE = 200;

/**
 * Calculates the estimated reading time for a case study
 * @param caseStudy - The case study object
 * @returns Reading time in minutes as a string
 */
export function calculateReadingTime(caseStudy: CaseStudy): string {
    let wordCount = 0;

    // Count words in overview
    wordCount += caseStudy.overview.summary.split(/\s+/).length;

    // Count words in challenge
    wordCount += caseStudy.challenge.description.split(/\s+/).length;
    caseStudy.challenge.points.forEach((point) => {
        wordCount += point.split(/\s+/).length;
    });

    // Count words in solution
    wordCount += caseStudy.solution?.description.split(/\s+/).length || 0;
    caseStudy.solution?.approaches.forEach((approach) => {
        wordCount += approach.description.split(/\s+/).length;
        approach.techniques.forEach((technique) => {
            wordCount += technique.split(/\s+/).length;
        });
    });

    // Count words in results
    caseStudy.results?.forEach((result) => {
        wordCount += result.description.split(/\s+/).length;
    });

    // Count words in tech details
    wordCount += caseStudy.tech_details.description.split(/\s+/).length;
    caseStudy.tech_details.architecture_highlights.forEach((highlight) => {
        wordCount += highlight.split(/\s+/).length;
    });

    // Count words in conclusion
    wordCount += caseStudy.conclusion.content.split(/\s+/).length;
    caseStudy.conclusion.key_takeaways.forEach((takeaway) => {
        wordCount += takeaway.split(/\s+/).length;
    });

    const minutes = Math.ceil(wordCount / WORDS_PER_MINUTE);
    return `~${minutes} min read`;
}
